import React from "react";
import "./components/ProjectProfile/ProfileContainer.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import Projects from "./components/ProjectProfile/Projects";
import NavigationBar from "./components/NavigationBar/NavigationBar";
import { Landing } from "./components/Search/Landing";
import Footer from "./components/Footer/Footer";
import SearchResults from "./components/SearchResults/SearchResults";
import IneligibilityList from "./components/Ineligibility/IneligibilityList";
import { Settings } from "./components/Settings/Settings.js";
import { NoMatch } from "./components/NoMatch/NoMatch";
import ProjectsList from "./components/ProjectsList/ProjectsList";
import Profile from "./components/Profile/Profile";
import Project from "./components/Project/Project";
import BannerCreator from "./components/BannerCreator/BannerCreator";
import BannerHistory from "./components/BannerHistory/BannerHistory.jsx";
import Pers from "./components/Pers/Pers";
import Edit from "./components/Edit/Edit";
import AddNewProject from "./components/AddNewProject/AddNewProject";
import { EditProject } from "./components/EditProject/EditProject";
import AddNewPhase from "./components/AddNewPhase/AddNewPhase";
import { AddNewPers } from "./components/AddNewPers/AddNewPers";
import { AddNewPersDecision } from "./components/AddNewPersDecision/AddNewPersDecision";
import PersEstablish from "./components/Pers-Establish";
import { AddEstablishedPers } from "./components/AddEstablishedPers/AddEstablishedPers.js";
import { Unauthorized } from "./components/Unauthorized/Unauthorized";
import ErrorPage from "./error-page";
import { ConditionalAvailable } from "./components/Letters/Conditional/Available/ConditionalAvailable";
import { ConditionalUnavailable } from "./components/Letters/Conditional/Unavailable/ConditionalUnavialable";
import { FinalApproval } from "./components/Letters/Final/Approval/FinalApproval";
import { IneligibleLetter } from "./components/Letters/Ineligible/Letter/IneligibleLetter";
import { SuspensionLetter } from "./components/Letters/Suspension/Letter/SuspensionLetter";
import { ChildPhase } from "./components/ChildPhase/ChildPhase";
import ChildPhasePage from "./components/ChildPhase/ChildPhasePage/ChildPhasePage";
import { Certification } from "./components/Certification/Certification";
import { ViewCertification } from "./components/ViewCertification/ViewCertification";
import { ViewPrintCertification } from "./components/ViewCertification/ViewPrintCertification";
import { Help } from "./components/Help/Help";
import { Reports } from "./components/Reports/Reports";
import RouteChangeTracker from "./RouteChangeTracker";
import WebFont from "webfontloader";
import { SessionTimeOutHandler } from "./components/SessionTimeOutHandler/SessionTimeOutHandler";
import { SessionErrorPage } from "./components/SessionTimeOutHandler/SessionErrorPage";
import ActiveBanner from "./components/ActiveBanner/ActiveBanner";
import ProjectErrorPage from "./components/Project/ProjectErrorPage";
import Admin from "./components/Admin/Admin";
import FeatureFlagDashboard from "./components/FeatureFlagDashboard/FeatureFlagDashboard";
import LenderRequestList from "./components/LenderRequests/List/LenderRequestList.js";
import {isAuthenticated} from "./components/shared/services/SharedService";
import {
  getUserDetail,
  isAdminRole
} from "./redux/actions/userAction.js";
import {connect} from 'react-redux';
import { CircularProgress } from "@material-ui/core";
import LenderRequest from "./components/LenderRequests/Details/LenderRequest.js";
import AdditionalDocuments from "./components/LenderRequests/RequestFeed/AdditionalDocuments/AdditionalDocuments.js";
import { 
  initializeFeatureToggles, 
  safeIdentifyUser
} from "./components/shared/services/featureToggle/FeatureToggleManager";
import { 
  LAUNCHDARKLY_CLIENT_SIDE_ID, 
  getDefaultUser, 
  createUser 
} from "./components/shared/services/featureToggle/LaunchDarklyConfig";
import { LenderEditPhase } from "./components/EditPhase/LenderEditPhase.js";
import { initializePendo } from "./components/shared/services/PendoService.js"
import { getEnvName } from "./components/shared/constants/environment.js"
import { loadPendoAnalytics } from "./components/shared/custom/pendo-script.js"
import CreateStatusReviewRequest from "./components/LenderRequests/CreateRequest/StatusReview/CreateStatusReviewRequest.js";

WebFont.load({
  google: {
    families: ["Source Sans Pro", "sans-serif"],
  },
});

class App extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      dialogueOpen: false,
      loading: true,
    };
  }

  dialogueCallback = (flag) => {
    this.setState({ dialogueOpen: flag });
  };

  async componentDidMount() {
    var passData = JSON.parse(sessionStorage.getItem("passData"));

    // load pendo analytics script
    loadPendoAnalytics(process.env.REACT_APP_PENDO_API_KEY);

    // Initialize LaunchDarkly feature toggles
    try {
      if (LAUNCHDARKLY_CLIENT_SIDE_ID) {
        await initializeFeatureToggles(LAUNCHDARKLY_CLIENT_SIDE_ID);
      }
    } catch (error) {
      // Continue with app initialization even if feature toggles fail
      // Error logged internally by FeatureToggleManager
    }

    if (!isAuthenticated()) {
      try {
        await this.props.getUserDetail();
        passData = JSON.parse(sessionStorage.getItem("passData"));
        
        // Update LaunchDarkly user context after successful authentication
        if (LAUNCHDARKLY_CLIENT_SIDE_ID) {
          try {
            if (this.props.user) {
              // User is available, identify them with LaunchDarkly
              const userContext = createUser(
                this.props.user.userId || this.props.user.id || 'authenticated-user',
                {
                  name: this.props.user.name || this.props.user.displayName,
                  email: this.props.user.email,
                  custom: {
                    isInternalUser: this.props.user.isInternalUser,
                    role: this.props.user.role,
                    department: this.props.user.department
                  }
                }
              );
              await safeIdentifyUser(userContext);
            } else {
              // User not available yet, identify with default anonymous user
              const defaultUser = getDefaultUser();
              await safeIdentifyUser(defaultUser);
            }
          } catch (userError) {
            // LaunchDarkly will continue working with the initial user context
          }
        }
      } catch (error) {
        // Handle authentication errors gracefully
      } finally {
        this.setState({loading: false});
      }
    } else {
      // User is already authenticated, update LaunchDarkly context if possible
      if (LAUNCHDARKLY_CLIENT_SIDE_ID && this.props.user) {
        try {
          const userContext = createUser(
            this.props.user.userId || this.props.user.id || 'authenticated-user',
            {
              name: this.props.user.name || this.props.user.displayName,
              email: this.props.user.email,
              custom: {
                isInternalUser: this.props.user.isInternalUser,
                role: this.props.user.role,
                department: this.props.user.department
              }
            }
          );
          safeIdentifyUser(userContext);
        } catch (userError) {
          // Continue silently if user context update fails
        }
      }
      this.setState({loading: false});
    }

    // initialize pendo only for authenticated user
    if (passData) {
        initializePendo(passData, getEnvName());
    }
  }

  HeadBar = () => {
    return (
      <React.Fragment>
        <NavigationBar dialogueCallback={this.dialogueCallback} />
      </React.Fragment>
    );
  };

  HandleSessionTime = () => {
    return (
      <React.Fragment>
        <SessionTimeOutHandler />
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loading) {
      return <div style={{ textAlign: "center" }}>
        <CircularProgress
          style={{ marginTop: "20px", color: "#1176b5" }}
        /><p style={{
          color: "#04314d",
          fontFamily: "Source Sans Pro, sans-serif",
          fontSize: "18px"
        }}>Loading...</p>
      </div>
    }
    return (
      <React.Fragment>
        <ActiveBanner />
        <RouteChangeTracker />

        <Router>
          <Route path="/unauthorized" component={Unauthorized} />
          {this.HeadBar()}
          {this.HandleSessionTime()}
          <Switch>
            <Route path="/projects" component={Projects} />
          </Switch>
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/condogo/*" component={Landing} />
            <Route exact path="/condoproject" component={Landing} />
            <Route exact path="/search/:search" component={SearchResults} />
            <Route path="/projects-list" component={ProjectsList} />
            <Route path="/IneligibilityList" component={IneligibilityList} />
            <Route path="/Settings" component={Settings} />
            <Route path="/help-center" component={Help} />
            <Route path="/project/pers/:project_id" component={Pers} />
            <Route
              path="/project/pers-establish/:project_id"
              component={PersEstablish}
            />
            <Route
              path="/project/phase/child-phase/:phase_id"
              component={ChildPhasePage}
            />
            <Route path="/banner/:banner_id" component={BannerCreator} />
            <Route path="/banner-history" component={BannerHistory} />
            <Route path="/project/phase/:project_id" component={Profile} />
            <Route path="/project/:project_id" component={Project} />
            <Route exact path="/edit/:edit_id" component={Edit} />
            <Route path="/addNewProject/:type" component={AddNewProject} />
            <Route path="/addNewProject/:type/success" component={AddNewProject} />
            <Route path="/editProject/:project_id" component={EditProject} />
            <Route path="/editProject/:project_id/success" component={EditProject} />
            <Route 
              path="/lender-project-request/additional-documents/:project_id/:request_id" 
              component={AdditionalDocuments} 
            />
            <Route 
              path="/lender-project-request/status-review/:project_id/create" 
              component={CreateStatusReviewRequest} 
            />
            <Route path="/lender-edit-phase/:project_id/:phase_id" component={LenderEditPhase} />
            <Route path="/lender-project-request/:project_id" component={LenderRequest} />
            <Route path="/lender-project-request" component={LenderRequestList} />
            <Route
              path="/conditional-available/:project_id/:pers_id/:pers_type"
              component={ConditionalAvailable}
            />
            <Route
              path="/conditional-unavailable/:project_id/:pers_id/:pers_type"
              component={ConditionalUnavailable}
            />
            <Route
              path="/final-approval/:project_id/:pers_id/:pers_type"
              component={FinalApproval}
            />
            <Route
              path="/ineligible-letter/:project_id/:pers_id/:pers_type"
              component={IneligibleLetter}
            />
            <Route
              path="/suspended/:project_id/:pers_id/:pers_type"
              component={SuspensionLetter}
            />
            <Route path="/addNewPhase/:project_id" component={AddNewPhase} />
            <Route
              path="/certification/:project_id/:phase_id/:status"
              component={Certification}
            />
            <Route path="/add-new-pers/:project_id" component={AddNewPers} />
            <Route
              path="/add-new-decision/:project_id/:pers_id/:pers_type"
              component={AddNewPersDecision}
            />
            <Route
              path="/add-child-phase/:project_id/:phase_id"
              component={ChildPhase}
            />
            <Route
              path="/add-established-pers/:project_id"
              component={AddEstablishedPers}
            />
            <Route path="/error-page" component={ErrorPage} />
            <Route
              path="/view-certification/:project_id/:phase_id/:status"
              component={ViewCertification}
            />

            <Route
              path="/print-certification/:cert_id/:project_id/:phase_id"
              component={ViewPrintCertification}
            />
            <Route path="/reports" component={Reports} />
            <Route path="/session-error-page" component={SessionErrorPage} />
            <Route path="/project-error-page" component={ProjectErrorPage} />
            <Route path="/admin" component={Admin} />
            <Route path="/feature-flags" component={FeatureFlagDashboard} />

            <Route path="/project-error-page" component={ProjectErrorPage} />
            <Route component={NoMatch} />
          </Switch>
          <Footer />
        </Router>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getUserDetail,
}

export default connect (null, mapDispatchToProps)(App);
